"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconContents = exports.Icons = void 0;
var tslib_1 = require("tslib");
/* tslint:disable */
var Icons = tslib_1.__importStar(require("./IconNames"));
exports.Icons = Icons;
var IconContents_1 = tslib_1.__importDefault(require("./IconContents"));
exports.IconContents = IconContents_1.default;
